

















import Vue from 'vue';
import UserHeader from './UserHeader.vue';
import UserMenu from './UserMenu.vue';

export default Vue.extend({
    components: {
        UserHeader,
        UserMenu,
    },
    async created() {
      this.$store.dispatch('getUserSummary');
    },
});
